import {Component, OnInit} from '@angular/core';
import {CertifyService} from '../services/certify.service'

@Component({selector: 'app-certificate', templateUrl: './certificate.component.html', styleUrls: ['./certificate.component.css']})
export class CertificateComponent implements OnInit {
    public allData : any = [];
    public certificateNumber = "";
    public certificate;
    public loading = false;

    constructor(private certifyService : CertifyService) {}

    ngOnInit(): void {}

    public filterData() {
        this.loading = true;
        this.certifyService.getCertificate(this.certificateNumber).subscribe(item => {
            this.certificate = item.body;
            // console.log(item)
            if (item.body != null) {
                this.certificate = item.body;

                this.certificate.subjectMarks = this.certificate.subjectMarks.split(",");
                // console.log(this.certificate.subjectMarks)
                this.loading = false;
            } else {
                this.certificate = "false";
                // console.log(this.certificate)
                this.loading = false;
            }

        }, err => {
            this.certificate = "false";
            // console.log(this.certificate)
            this.loading = false;
        });
    }

}
